// extracted by mini-css-extract-plugin
export default {"dark-mode-switch":"DarkModeSwitch_dark-mode-switch__f2US0","dark":"DarkModeSwitch_dark__Sn2hm","flip-horizontal":"DarkModeSwitch_flip-horizontal__ua7wH"};